/**
 * Skeleton Component
 *
 * Loading skeleton with pulse animation
 * Respects prefers-reduced-motion for accessibility
 */

'use client';

import * as React from 'react';
import { cn } from '../utils/cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-[var(--color-secondary-200)]',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
